/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type {
  GetTransportsColorsIdPathParams,
  GetTransportsColorsId200,
  GetTransportsColorsId400,
  GetTransportsColorsIdQueryResponse,
} from '../entities/GetTransportsColorsId'
import type { ToZod } from '@kubb/plugin-zod/utils'
import { errorStructSchema } from './errorStructSchema'
import { v1GetTransportColorsResponseSchema } from './v1/getTransportColorsResponseSchema'
import { z } from 'zod'

export const getTransportsColorsIdPathParamsSchema = z.object({
  id: z.number().int().describe('Transport type ID'),
}) as unknown as ToZod<GetTransportsColorsIdPathParams>

/**
 * @description OK
 */
export const getTransportsColorsId200Schema = z.lazy(() => v1GetTransportColorsResponseSchema) as unknown as ToZod<GetTransportsColorsId200>

/**
 * @description Bad Request
 */
export const getTransportsColorsId400Schema = z.lazy(() => errorStructSchema) as unknown as ToZod<GetTransportsColorsId400>

export const getTransportsColorsIdQueryResponseSchema = z.lazy(() => getTransportsColorsId200Schema) as unknown as ToZod<GetTransportsColorsIdQueryResponse>